"use strict";
/**
* This is an auto generated code. This code should not be modified since the file can be overwritten
* if new genezio commands are executed.
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServicePostgresql = void 0;
var genezio_remote_1 = require("genezio-remote");
/**
 * The User server class that will be deployed on the genezio infrastructure.
 */
var UserServicePostgresql = /** @class */ (function () {
    function UserServicePostgresql() {
    }
    /**
     * Method that can be used to create a new user.
     * * The method will be exported via SDK using genezio.
     * * @param {string} email The user's email.
     * @param {string} password The user's password.
     * @returns {Promise<UserLoginResponse>} An object containing a boolean property "status" which
     * is ok if the creation was successfull, error otherwise.
     */
    UserServicePostgresql.register = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.register", email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Method that can be used to obtain a login token for a giving user.
     * * The method will be exported via SDK using genezio.
     * * @param {string} email The user's email.
     * @param {string} password The user's password.
     * @returns {Promise<UserLoginResponse>} An object containing a boolean property "status" which
     * is ok if the login was successfull, error otherwise.
     */
    UserServicePostgresql.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.login", email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Methods that receives a token and confirms if it is valid or not.
     * * @param {string} token The user's token.
     * @returns {Promise<CheckSessionResponse>} An object containing a boolean property "status" which is ok if the token is valid, error otherwise.
     */
    UserServicePostgresql.checkSession = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.checkSession", token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Sends a password reset token to a user's email.
     * @param {string} email - The user's email address.
     * @returns {Promise<ResetPasswordResponse>} An object with a boolean property "status" indicating success or failure.
     */
    UserServicePostgresql.resetPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.resetPassword", email)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Resets the user's password.
     * @param {string} token - The token received from the resetPassword method.
     * @param {string} password - The new password.
     * @returns {Promise<ResetPasswordConfirmResponse>} An object with a boolean property "status" indicating success or failure.
     */
    UserServicePostgresql.resetPasswordConfirmation = function (token, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.resetPasswordConfirmation", token, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Confirms the user's email address.
     * @param {string} token - The token received from the register method.
     * @returns {Promise<EmailConfirmationResponse>} An object with a boolean property "status" indicating success or failure.
     */
    UserServicePostgresql.emailConfirmation = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.emailConfirmation", token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Resends the email confirmation token.
     * @param {string} email
     * @returns {Promise<ResendEmailConfirmationResponse>} An object with a boolean property "status" indicating success or failure.
     */
    UserServicePostgresql.resendEmailConfirmation = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.resendEmailConfirmation", email)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Vote system
     * @param {string} email
     * @param {string} idConcurent
     * @param {string} gender
     * @returns {Promise<VoteResponse>} An object with a boolean property "status" indicating success or failure.
     */
    UserServicePostgresql.voteConcurenti = function (email, idConcurent, gender, token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.voteConcurenti", email, idConcurent, gender, token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserServicePostgresql.canVote = function (email, token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.canVote", email, token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserServicePostgresql.getConcurenti = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.getConcurenti", token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserServicePostgresql.getUsers = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.getUsers", token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserServicePostgresql.isAdmin = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserServicePostgresql.remote.call("UserServicePostgresql.isAdmin", token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserServicePostgresql.remote = new genezio_remote_1.Remote("https://bviduan5zpfqttb6fke4556sly0ymswi.lambda-url.eu-central-1.on.aws/UserServicePostgresql");
    return UserServicePostgresql;
}());
exports.UserServicePostgresql = UserServicePostgresql;
